import { API_TYPE } from "../../constants";
import { makeApiCall } from "../makeApiCall";
import { CheckerService_URL } from "../Url";

export const CheckerTOActions = {
  FETCH_MED_DETAILS_FOR_BOX_SUCCESS: "FETCH_MED_DETAILS_FOR_BOX_SUCCESS",
  FETCH_MED_DETAILS_FOR_BOX_FAILURE: "FETCH_MED_DETAILS_FOR_BOX_FAILURE",
  FETCH_BATCH_FOR_BOX_SUCCESS: "FETCH_BATCH_FOR_BOX_SUCCESS",
  FETCH_BATCH_FOR_BOX_FAILURE: "FETCH_BATCH_FOR_BOX_FAILURE",
};

export function fetchTOMedicineDetailsForBoxSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: CheckerTOActions.FETCH_MED_DETAILS_FOR_BOX_SUCCESS,
      payload: props,
    });
  };
}

export function fetchTOMedicineDetailsForBoxError(error) {
  return {
    type: CheckerTOActions.FETCH_MED_DETAILS_FOR_BOX_FAILURE,
    payload: error,
  };
}

export function fetchTOMedicineDetailsForBoxThunk(params) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + params.access_token,
  };
  let url = `${CheckerService_URL}/fetchTOMedicineDetailsForBox?`;

  let tempUrl = "";
  if (Object.keys(params).length > 0) {
    Object.keys(params).forEach((e) => {
      switch (e) {
        case "toNumber":
          tempUrl += `&toNumber=${params.toNumber}`;
          break;
        case "boxNumber":
          tempUrl += `&boxNumber=${params.boxNumber}`;
          break;
        default:
          break;
      }
    });
  }
  if (tempUrl) {
    tempUrl = tempUrl.slice(1);
  }

  url += tempUrl;

  return makeApiCall(
    url,
    fetchTOMedicineDetailsForBoxSuccess,
    fetchTOMedicineDetailsForBoxError,
    "GET",
    null,
    reqHeader,
    params.history,
    API_TYPE.NEW
  );
}

// ---------------

export function fetchCheckerBatchForBoxSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: CheckerTOActions.FETCH_BATCH_FOR_BOX_SUCCESS,
      payload: props,
    });
  };
}

export function fetchCheckerBatchForBoxError(error) {
  return {
    type: CheckerTOActions.FETCH_BATCH_FOR_BOX_FAILURE,
    payload: error,
  };
}

export function fetchCheckerBatchForBoxThunk(params) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + params.access_token,
  };
  let url = `${CheckerService_URL}/itemAvailableStock?`;
  let tempUrl = "";
  if (Object.keys(params).length > 0) {
    Object.keys(params).forEach((e) => {
      switch (e) {
        case "toNumber":
          tempUrl += `&toNumber=${params.toNumber}`;
          break;
        case "boxNumber":
          tempUrl += `&boxNumber=${params.boxNumber}`;
          break;
        case "warehouseId":
          tempUrl += `&warehouseId=${params.warehouseId}`;
          break;
        default:
          break;
      }
    });
  }
  if (tempUrl) {
    tempUrl = tempUrl.slice(1);
  }

  url += tempUrl;

  return makeApiCall(
    url,
    fetchCheckerBatchForBoxSuccess,
    fetchCheckerBatchForBoxError,
    "POST",
    null,
    reqHeader,
    params.history,
    API_TYPE.NEW
  );
}
